import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { AuthContext } from "../context/AuthContext";

export default function LoginScreen() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      setUser(cred.user);
      navigate("/izbira");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center", marginBottom: 30 }}>Prijava</h1>

      <div style={cardStyle}>
        <input
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <input
          placeholder="Geslo"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        <button style={buttonStyle} onClick={handleLogin}>Prijava</button>
      </div>

      <p style={{ textAlign: "center", marginTop: 15 }}>
        Nimaš računa?{" "}
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => navigate("/registracija")}
        >
          Registriraj se
        </span>
      </p>
    </div>
  );
}

// --- Styling ---
const containerStyle = {
  maxWidth: "400px",
  margin: "80px auto",
  padding: 20,
  fontFamily: "Arial, sans-serif"
};

const cardStyle = {
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "15px"
};

const inputStyle = {
  padding: "10px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14
};

const buttonStyle = {
  padding: "10px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 14
};
